/**
 * @generated SignedSource<<952942a1454d513c4c15c03bd3548c7e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CompetitionTagFragment$data = {
  readonly name: string;
  readonly " $fragmentType": "CompetitionTagFragment";
};
export type CompetitionTagFragment$key = {
  readonly " $data"?: CompetitionTagFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"CompetitionTagFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CompetitionTagFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    }
  ],
  "type": "Tag",
  "abstractKey": null
};

(node as any).hash = "c8d02d204498a8f589729256c60a2633";

export default node;
